export function Progress({ isSaving = false, label = "Progress", value = 0 }) {
  return (
    <>
      <div id="progresslabel" className="text-gray-800 text-sm">
        {label}
      </div>
      <div
        aria-labelledby="progresslabel"
        aria-valuenow={value}
        className="up-progress-bar"
        role="progressbar"
      >
        <div
          className={isSaving ? "animate" : ""}
          style={{
            width: `${value}%`,
          }}
        ></div>
      </div>
    </>
  );
}
